export default {
  // Connexion
  login: {
    lang: 'Langue',
    systemname: 'Login Facial',
    username: 'Utilisateur',
    username_label: "Veuillez saisir l'utilisateur",
    pwd: 'Mot de passe',
    pwd_label: 'Veuillez saisir le mot de passe',
    pwd_info: 'Entrez un mot de passe valide',
    success_msg: 'Connexion réussie',
    error_name: 'Mot de passe incorrect',
    error_res: "Ne répond pas aux exigences de connexion",
    login: 'Se connecter',
  },
  // Barre latérale
  aside: {
    systemname: 'Console',
    quit: 'Quitter',
    deviceControl: 'Contrôle',
    basicSetting: 'Réglages',
    workerSetting: 'Personnel',
    deviceMonitoring: 'Surveillance',
    recordManagement: 'Journal',
    securityManagement: 'Des clés',
    tips: 'Conseil',
    tips_msg: 'Voulez-vous vous déconnecter ?',
  },
  // Contrôle
  control: {
    remoteControl: 'Distance',
    restart: 'Redémarrer',
    clickToRestart: 'Cliquer pour redémarrer',
    restartConfirm: 'Confirmer le redémarrage ?',
    restartSuccess: 'Redémarrage réussi',
    restartFailed: 'Redémarrage échoué',
    remoteOpen: 'Ouverture à distance',
    clickToOpen: 'Cliquer pour ouvrir',
    openConfirm: "Confirmer l'ouverture à distance ?",
    remoteOpenSuccess: 'Ouverture réussie',
    remoteOpenFailed: "Ouverture échouée",
    reset: 'Réinitialiser',
    clickToReset: 'Cliquer pour réinitialiser',
    resetConfirm: 'Confirmer la réinitialisation ?',
    resetSuccess: 'Réinitialisation réussie',
    resetFailed: 'Réinitialisation échouée',
    firmwareUpgrade: 'Mise à jour du firmware',
    upgradeConfig: 'Config. mise à jour',
    firmwareUrl: 'URL du firmware',
    md5Checksum: 'Valeur md5',
    startUpgrade: 'Démarrer la mise à jour',
    urlRequired: "L'URL est requise",
    md5Required: 'Le md5 est requis',
    urlInvalid: 'Entrez une URL valide',
    md5Invalid: 'Entrez un md5 valide',
    upgradeConfirm: 'Confirmer la mise à jour ?',
    upgradeSuccess: 'Mise à jour réussie',
    clearFile: "Effacer le fichier",
    uploading: 'Téléversement...',
    uploadAndUpgrade: 'Téléverser et mettre à jour',
    restartTips: 'Redémarrage sécurisé, sans perte de données',
    restarting: 'Redémarrage...',
    remoteTips: 'Contrôle distant de la porte',
    opening: 'Ouverture...',
    resetTips: 'Restauration usine, effacera les données',
    reseting: 'Réinitialisation...',
    urlUpgrade: 'Mise à jour par URL',
    fileUpgrade: 'Mise à jour par fichier',
    uploadFile: 'Cliquez pour téléverser le firmware',
    formatFile: 'Supporte .zip ou .dpk, max 20MB',
    fileName: 'Nom du fichier',
    size: 'Taille',
  },
  // Configuration
  config: {
    second: 's',
    millisecond: 'ms',
    min: 'minutes',
    notsave: 'Ne pas enregistrer',
    save: 'Enregistrer',
    noVoice: 'Sans voix',
    no: 'Non',
    yes: 'Oui',
    basicConfiguration: 'Configuration de base',
    displaySettings: 'Affichage',
    informationDisplay: "Affichage d'information",
    audioSettings: 'Audio',
    languageAndThemes: 'Langue et thème',
    autoAdjustScreenBrightness: 'Luminosité auto',
    screenBrightness: 'Luminosité écran',
    autoTurnOffScreen: 'Extinction auto',
    autoTurnOffScreenTime: "Temps d'extinction",
    autoScreenSaver: 'Économiseur auto',
    autoScreenSaverTime: 'Délai économiseur',
    displayDeviceSn: 'Afficher SN',
    displayIp: 'Afficher IP',
    displayIdentityCard: 'Afficher certificat cloud',
    volume: 'Volume',
    language: 'Langue',
    displayCode: "Afficher code miniapp",
    themeMode: "Thème",
    cn: 'Chinois',
    en: 'Anglais',
    es: 'Espagnol',
    fr: 'Français',
    de: 'Allemand',
    ru: 'Russe',
    ar: 'Arabe',
    pt: 'Port.',
    ko: 'Coréen',
    standardMode: 'Mode standard',
    simpleMode: 'Mode simple',
    firstLogin: 'Première connexion',
    backlight: 'Rétroéclairage',
    brightness: 'Lumière blanche',
    nirBrightness: 'Lumière IR',
    never: 'Jamais',
    min1: '1 minute',
    min2: '2 minutes',
    min3: '3 minutes',
    min4: '4 minutes',
    min5: '5 minutes',
    networkConfiguration: 'Réseau',
    otherConfiguration: 'Autres',
    ipConfiguration: 'Adresse IP',
    devicePassword: 'Mot de passe appareil',
    protocolPassword: 'Mot de passe protocole',
    networkType: 'Type de réseau',
    ethernet: 'Ethernet',
    wifiName: 'Wi‑Fi',
    wifiPassword: 'Mot de passe Wi‑Fi',
    dhcpModeSelection: 'Mode DHCP',
    dhcpMode: 'Automatique',
    customNetworkConfiguration: 'Manuel',
    ipAddress: 'IP',
    gateway: 'Passerelle',
    subnetMask: 'Masque',
    dnsServer: 'DNS',
    mac: 'MAC',
    mqttRelatedConfiguration: 'MQTT',
    mqttConnectionInformation: 'Connexion MQTT',
    sessionConfiguration: 'Session',
    serverAddress: 'Serveur',
    clientID: 'ID client',
    userName: "Nom d'utilisateur",
    userPassword: 'Mot de passe',
    topicPrefix: 'Préfixe de topic',
    onlineChecking: 'Vérification en ligne',
    onlineCheckingTimeout: "Délai d'attente",
    cleanSession: 'Session propre',
    clientIdSuffix: "Suffixe d'ID client",
    willTopic: 'Topic Will',
    enterpriseWechat:'Mode WeChat Entreprise sans effet',
    faceRelatedConfiguration: 'Configuration faciale',
    functionalInformation: 'Fonction',
    prompt: 'Invite',
    faceSimilarityThreshold: 'Seuil de similarité',
    livenessDetectionFunction: 'Détection de vivacité',
    livenessDetectionThreshold: 'Seuil de vivacité',
    infraredImageDisplay: "Affichage infrarouge",
    maskRecognition: "Reconnaissance de masque",
    strangerVoice: "Voix d'inconnu",
    voiceMode: "Mode voix",
    voiceModeDate: 'Salutation personnalisée',
    imageSaveType: "Type de sauvegarde",
    saveStrangerImage: "Sauver image d'inconnu",
    fullView: "Panorama",
    face: "Visage",
    broadcastPleaseRegisterFirst: 'Diffuser "Veuillez vous enregistrer"',
    broadcastHelloStranger: 'Diffuser "Inconnu"',
    broadcastName: 'Diffuser le nom',
    broadcastGreeting: 'Diffuser salutation personnalisée',
    greeting: 'Salutation',
    broadcastWelcome: 'Diffuser "Bienvenue"',
    recognitionSwitch: 'Interrupteur de re-détection',
    systemRelatedConfiguration: 'Système',
    functionSwitch: 'Commutateurs',
    cardSwipingSwitch: 'Carte',
    passwordSwitch: 'Mot de passe',
    strangerImage: 'Image inconnue',
    cloudCertificateSwitch: 'Certificat cloud',
    physicalCardNumber: 'Numéro de carte physique',
    cloudCertificateAcquisition: 'Obtention certificat cloud',
    heartbeatConfig: 'Heartbeat',
    heartbeatSwitch: 'Activer heartbeat',
    heartRateInterval: 'Intervalle',
    heartbeatTopic: 'Topic heartbeat',
    heartbeatContent: 'Contenu',
    basicInformation: 'Infos de base',
    deviceMac: 'MAC',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Modèle',
    version: "Version",
    appVersion: "Version firmware",
    releaseTime: "Date de mise à jour",
    totaldisk: 'Volume total',
    freedisk: 'Espace restant',
    passageConfiguration: 'Passage',
    functionConfiguration: 'Fonctions',
    numberOfPassageRecords: 'Nb. max de passages',
    durationOfRelayOpening: "Durée d'ouverture du relais",
    alarmSwitch: 'Alarme',
    fireAlarmSwitch: "Alarme incendie",
    fireAlarmStatus: 'État incendie',
    normal: 'Normal',
    warning: 'Alerte',
    tamperSwitch: 'Anti-sabotage',
    uploadToCloudSwitch: 'Interrupteur de téléversement facial',
    clockConfiguration: 'Horloge',
    timeSynchronizationSwitch: 'Synchronisation horaire',
    timeSynchronizationServerIP: 'Serveur de temps',
    timedSynchronizationTime: 'Heure de synchro',
    timeZone: 'Fuseau horaire',
    setDeviceTime: "Régler l'heure",
    restartAfterSetting: "L'appareil redémarrera",
    cloudCertificateActivation: 'Activation du certificat',
    activationKey: "Clé d'activation",
    cloudTips1: 'Entrez la clé sans espaces',
    cloudTips2: "Après activation, connexion au service cloud",
    confirmActivation: "Confirmer l'activation",
    activationInProgress: 'Activation...',
    activationFailed: 'Échec activation',
    activationSuccessful: 'Activation réussie',
    passwordModification: 'Modifier le mot de passe',
    password: 'Mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer mot de passe',
    passwordRule: 'Recommandations',
    passwordLength: 'Longueur ≥6',
    cannotBeTheSame: 'Tous les caractères ne peuvent être identiques',
    cannotOrder: 'Pas de 3+ nombres/lettres consécutifs',
    cannotWeakPassword: 'Pas de mot de passe faible',
    submit: 'Soumettre',
    saveConfig: 'Enregistrer',
    msg_please_enter: 'Veuillez saisir',
    msg_inputPassword: 'Veuillez saisir le mot de passe',
    msg_oldPasswordError: 'Ancien mot de passe incorrect',
    msg_password_mismatch: 'Les mots de passe ne correspondent pas',
    msg_password_min_length: 'Au moins 6 caractères',
    msg_is_weak_password: 'Mot de passe faible, changez-le',
    msg_pswChangeSuccessAndLogin: 'Mot de passe changé, reconnectez-vous',
    msg_pswChangeSuccess: 'Mot de passe modifié',
    msg_pswChangeFail: 'Échec de modification',
    msg_saveSuccess: 'Enregistré',
    msg_saveFail: "Échec de l'enregistrement",
    msg_formFilled: 'Vérifiez le formulaire',
    msg_number_0_23: 'Supporte seulement 0-23',
    msg_number_0_24: 'Supporte seulement 0-24',
    msg_noChange: 'Aucun changement de configuration à enregistrer',
    resourceConfiguration: 'Configuration des ressources',
    backgroundImage: 'Image de fond',
    selectImage: 'Choisir une image',
    uploadBackground: 'Téléverser le fond',
    uploading: 'Téléversement...',
    backgroundUploadTip: 'Téléversez une image PNG avec un nombre de pixels égal à {n}; convertie en Base64 puis envoyée',
    backgroundResolutionMismatch: "La résolution de l'image doit être {n}",
    backgroundRequired: "Veuillez choisir l'image de fond",
    backgroundImageOnlyPNG: 'Seulement PNG',
    backgroundSizeLimit: "La taille ne doit pas dépasser 5MB",
    backgroundParseFailed: "Échec de lecture de l'image",
    backgroundImageSelected: 'Image sélectionnée',
    backgroundSuccess: 'Fond téléversé',
    backgroundFailed: 'Échec du téléversement',
    scanSettings: 'Paramètres de scan',
    scanSwitch: 'Interrupteur de Scan',
    scanInterval: 'Intervalle de scan',
  },
  person: {
    idCard: "Numéro d'identité",
    userType: 'Type de personne',
    administrator: 'Administrateur',
    userId: 'ID',
    user: 'Utilisateur',
    voucher: 'Credential',
    permission: 'Permission',
    addUser: 'Ajouter une personne',
    name: 'Nom',
    editUser: 'Modifier personne',
    placeholderUserId: "Entrez l'ID utilisateur",
    placeholderName: 'Entrez le nom',
    userNotExist: "La personne n'existe pas",
    oneClickClear: 'Tout effacer',
    clearTips: 'Cette action effacera toutes les données, continuer ?',
    clearSuccess: 'Effacé avec succès',
    clearFailed: 'Échec de suppression',
  },
  voucher: {
    password: 'Mot de passe',
    card: 'Carte',
    face: 'Visage',
    finger: 'Empreinte',
    code: 'Code',
    codeType: 'Type de code',
    passthroughCode: 'Code de transit',
    staticCode: 'Code statique',
    dynamicCode: 'Code dynamique',
    placeholderCode: 'Veuillez saisir le certificat de code',
    placeholderPwd: 'Entrez le mot de passe',
    placeholderCard: 'Entrez la carte',
    validPassword: 'Entrez 6 chiffres',
    validCard: 'Entrez 8 chiffres ou lettres',
    photoRegistration: "Enregistrement d'image",
    featureValueRegistration: 'Enregistrement de caractéristiques',
    fingerRegistration: "Enregistrement d'empreinte",
    fingerFeatureRegistration: 'Enregistrement par valeur de caractéristique',
    fingerInput: "Veuillez poser votre doigt sur le lecteur d'empreintes",
    fingerRemainingTime: 'Temps restant',
    fingerInputting: 'En cours...',
    startFingerInput: "Démarrer l'enregistrement d'empreinte",
    fingerInputTips: "Veuillez saisir la valeur de caractéristique de l'empreinte",
    fingerWaitInput: 'En attente',
    fingerInputNow: "Enregistrement de l'empreinte...",
    fingerInputSuccess: 'Enregistrement réussi',
    fingerInputFailed: "Échec du démarrage de l'enregistrement d'empreinte",
    fingerReTry: "Échec de l'enregistrement d'empreinte, veuillez réessayer",
    fingerFilled: "Enregistrement réussi, la valeur de caractéristique a été remplie automatiquement",
    fingerFailed: "Échec de l'enregistrement d'empreinte",
    fingerTimeout: 'Délai dépassé',
    fingerInputTimeout: "Délai dépassé pour l'enregistrement d'empreinte, veuillez réessayer",
    fingerError: 'Échec de la saisie',
    fingerInputError: "Échec de l'enregistrement d'empreinte, veuillez réessayer",
    fingerInputed: 'Empreinte déjà enregistrée',
    fingerReInput: "Réenregistrer l'empreinte",
  },
  permission: {
    deletePermission: 'Supprimer permission',
    addPermission: 'Ajouter permission',
    permissionId: 'ID permission',
    userId: 'ID utilisateur',
    timeRange: 'Plage horaire',
    extra: 'Extra',
    effectiveType: 'Type de validité',
    effectiveTime: 'Temps effectif',
    effectiveWeek: 'Semaine effective',
    timePeriod: 'Période',
    addTimePeriod: 'Ajouter une période',
    modify_previous_time: 'Modifiez la période précédente',
    cannot_be_earlier: "L'heure de fin ne peut être avant le début",
    times_cannot_overlap: 'Les horaires ne peuvent se chevaucher',
    choose_time_range: 'Choisissez une plage horaire',
    unlimitedMode: 'Illimité',
    usualMode: 'Mode habituel',
    dailyMode: 'Mode quotidien',
    weeklyRepetitionMode: 'Répétition hebdo',
    time_range: 'Plage horaire',
  },
  common: {
    startDate: 'Date début',
    endDate: 'Date fin',
    to: 'à',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    delete: 'Supprimer',
    edit: 'Modifier',
    batchDelete: 'Suppression multiple',
    startTime: 'Heure début',
    endTime: 'Heure fin',
    monday: 'Lundi',
    tuseday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saterday: 'Samedi',
    sunday: 'Dimanche',
    placeholder: 'Veuillez saisir',
    placeholderSelect: 'Veuillez sélectionner',
    closeTips: 'Confirmer la fermeture ?',
    deleteTips: 'Confirmer la suppression ?',
    deleteSuccess: 'Suppression réussie',
    addSuccess: 'Ajout réussi',
    editSuccess: 'Modification réussie',
    saveSuccess: 'Enregistré avec succès',
    tips: 'Conseil',
    operation: 'Opération',
    query: 'Rechercher',
    reset: 'Reset',
    noData: 'Pas de données',
    export: 'Exporter',
    success: 'Succès',
    failure: 'Échec',
    incorrectFormat: 'Format incorrect',
    integerFormat: 'Doit être un entier ≥0',
    positiveIntegerFormat: 'Doit être un entier >0',
    noDataSaved: 'Aucune donnée à enregistrer',
    chinese: 'Chinois',
    english: 'Anglais',
    spanish: 'Espagnol',
    french: 'Français',
    german: 'Allemand',
    russian: 'Russe',
    arabic: 'Arabe',
    portuguese: 'Portugais',
    korean: 'Coréen',
    detail: 'Détail',
    clearTips: 'Confirmer l\'effacement?',
    clearSuccess: 'Effacé avec succès',
  },
  log: {
    accessMethod: "Méthode d'accès",
    passingTime: 'Heure de passage',
    accessPass: 'Credential',
    accessResult: 'Résultat',
    accessPhoto: 'Photo',
    viewPhotos: 'Voir photos'
  },
  error: {
    networkError: 'Échec réseau, vérifiez la connexion',
    timeout: 'Délai dépassé, réessayez',
    serverError: 'Erreur interne serveur, réessayez',
    notFound: "La ressource n'existe pas",
    unauthorized: 'Non autorisé, reconnectez-vous',
    noResponse: 'Impossible de contacter le serveur',
    unknownError: 'Échec de la requête, code :',
    requestFailed: 'Requête échouée'
  },
  security: {
    keyId: 'ID de clé',
    keyType: 'Type de clé',
    keyEncoding: 'Encodage de clé',
    keyValue: 'Valeur de clé',
    startTime: 'Heure de début',
    expirationTime: 'Heure d\'expiration',
    newKey: 'Ajouter une clé',
    clearKey: 'Effacer la clé',
    validTime: 'Durée de validité',
  }
}


